import Icon from '../components/Icon.vue'

Icon.register({
  ruler: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M635.7 167.2c8.8 15 3.6 34.2-11.6 42.8l-496.8 281.9c-15.2 8.6-34.7 3.5-43.5-11.5l-79.6-135.6c-8.8-15-3.5-34.1 11.7-42.8l69-39.1 59.7 101.4c2.2 3.8 7.1 5.1 10.9 2.9l13.8-7.8c3.8-2.2 5.1-7 2.9-10.7l-59.7-101.7 55.2-31.3 27.9 47.5c2.2 3.8 7.1 5.1 10.9 2.9l13.8-7.8c3.8-2.2 5.1-6.9 2.9-10.7l-27.9-47.4 55.2-31.3 59.7 101.7c2.2 3.8 7.1 5.1 10.9 2.9l13.8-7.8c3.8-2.2 5.1-7 2.9-10.7l-59.8-101.7 55.2-31.3 27.9 47.3c2.2 3.8 7.1 5.1 10.9 2.9l13.8-7.8c3.8-2.2 5.1-6.9 2.9-10.7l-27.9-47.4 55.2-31.3 59.7 101.6c2.2 3.8 7.1 5.1 10.9 2.9l13.8-7.8c3.8-2.2 5.1-6.9 2.9-10.7l-59.7-101.7 69-39.1c15.2-8.6 34.7-3.5 43.5 11.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ruler.js
// module id = 1855
// module chunks = 0